<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <defs>
      <clipPath id="master_svg0_436_06501">
        <rect x="0" y="14" width="14" height="14" rx="0" />
      </clipPath>
    </defs>
    <g style="mix-blend-mode: passthrough">
      <g
        style="mix-blend-mode: passthrough"
        transform="matrix(1,0,0,-1,0,28)"
        clip-path="url(#master_svg0_436_06501)"
      >
        <g style="mix-blend-mode: passthrough">
          <path
            d="M11.374714375,18.661987935211183C11.374714375,18.661987935211183,6.999694375,22.92761093521118,6.999694375,22.92761093521118C6.999694375,22.92761093521118,2.624675375,18.661987935211183,2.624675375,18.661987935211183C2.542716375,18.58002943521118,2.4470493749999997,18.539050158211182,2.337674375,18.539050158211182C2.228298375,18.539050158211182,2.132631375,18.58002943521118,2.050672375,18.661987935211183C1.9687137749999999,18.743945935211183,1.927734375,18.839612935211182,1.927734375,18.948987935211182C1.927734375,19.058362935211182,1.964192875,19.14950893521118,2.037110375,19.222424935211183C2.037110375,19.222424935211183,6.699134375,23.761480935211182,6.699134375,23.761480935211182C6.781094375,23.84345093521118,6.881424375,23.884420935211182,7.000134375,23.884420935211182C7.118844375,23.884420935211182,7.219174375,23.84345093521118,7.301134375,23.761480935211182C7.301134375,23.761480935211182,11.963134375,19.23598793521118,11.963134375,19.23598793521118C12.036034375,19.15402893521118,12.072534375,19.05602893521118,12.072534375,18.94198793521118C12.072534375,18.827945935211183,12.031634375,18.73227893521118,11.949634375,18.65498793521118C11.867604375,18.57769613521118,11.771974375,18.53890414821118,11.662594375,18.53861248115118C11.553224375,18.538320814211183,11.457584375,18.579300035211183,11.375594375,18.66154993521118C11.375594375,18.66154993521118,11.374714375,18.661987935211183,11.374714375,18.661987935211183C11.374714375,18.661987935211183,11.374714375,18.661987935211183,11.374714375,18.661987935211183Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallArrowTop',
} as DefineComponent
</script>
